// const defaultSelect = () => {
//     const element = document.querySelector('.about-form__item');
//     const choices = new Choices(element, {
//         searchEnabled: true,
//     });
// };

// defaultSelect();

const multiDefault = () => {
    const elements = document.querySelectorAll('.about-form__item');

    elements.forEach(el => {
        const choices = new Choices(el, {
            searchEnabled: false,
            allowHTML: true,
        });
    });
};


multiDefault();

